module.exports = __webpack_public_path__ + "img/back.71e44255.png";